module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_nucleosomes_and_chromatin_4-b45457dddb2098fdccdcfce3e1d4a04b.jpg";